module.exports = __webpack_public_path__ + "static/media/clockFinal.cb73f878.gif";